export const CUSTOMER_SUCCESS = {
  ADD_TENANT: 'Add tenant',
  TENANT_CREATED: 'Tenant created',
  SEARCH_PLACEHOLDER: 'Search tenants or Security Managers',
  ALL: 'All',
  FILTER_BY_SECURITY_MANAGER: 'Filter by Security Manager',
  FILTER_BY_STANDARD: 'Filter by standard',
  UNASSIGNED: 'Unassigned',
  NOT_SET: 'not set',
  IN_PROGRESS: 'In progress',
  DAYS: (days: number) => `${days} days`,
  INTERNAL: 'Internal',
  EXTERNAL: 'External',
  SUBTITLE:
    'Implementation status of every tenant: capabilities live, onboarding time, time to audit and adoption rate',
  TABS: { KPIS: 'KPIs', TENANTS: 'Tenants' },
  KPIS: {
    ACTIVE_ACCOUNTS: 'Active accounts',
    ACTIVE_ACCOUNTS_DETAIL: (live: number, followUp: number) => `${live} live · ${followUp} in follow-up`,
    CLIENTS_PER_SECURITY_MANAGER: 'Clients per Security Manager',
    SECURITY_MANAGERS_DETAIL: (count: number, top: string, accounts: number) =>
      `${count} Security Managers · top ${top} with ${accounts}`,
    ARR: 'ARR',
    ARR_DETAIL: (arr: string) => `${arr} per Security Manager`,
    AVG_ONBOARDING_TIME: 'Avg onboarding time',
    ONBOARDING_DETAIL: (onboarded: number, total: number, target: number) =>
      `${onboarded} of ${total} fully onboarded · target ${target} days`,
    AVG_TIME_TO_AUDIT: 'Avg time to audit',
    TIME_TO_AUDIT_DETAIL: 'Onboarding date to first internal audit',
    AVG_ADOPTION_RATE: 'Avg adoption rate',
    ADOPTION_DETAIL: 'In-scope capabilities enabled and in use',
    ARR_PER_SECURITY_MANAGER: 'ARR per Security Manager',
    ACCOUNTS_PER_SECURITY_MANAGER: 'Accounts per Security Manager',
    ACCOUNTS: 'Accounts',
    AVG_ADOPTION: (rate: number) => `${rate}% avg adoption`,
    NO_SECURITY_MANAGERS: 'No Security Managers assigned',
  },
  DRAWER: {
    ATTRIBUTES: 'Attributes',
    DATES: 'Dates',
    METRICS: 'Metrics',
    ONBOARDING_TIME_INFO: 'Days until every in-scope capability has its first result (a scan or data loaded).',
    ADOPTION_RATE_INFO: 'Percentage of in-scope capabilities that are enabled and used in the last 7 days.',
    NOTES: 'Notes',
    NO_NOTES: 'No notes',
    OVERVIEW: 'Overview',
    CAPABILITIES: 'Capabilities',
    TIMELINES: 'Timelines',
    SHOW_ON_HOME: 'Show on home',
    MILESTONES: (count: number) => (count === 1 ? '1 milestone' : `${count} milestones`),
    MILESTONE_NAME: 'Name',
    MILESTONE_DATE: 'Date',
    ADD_MILESTONE: 'Add milestone',
    REMOVE_MILESTONE: 'Remove milestone',
    NO_STANDARDS: 'No standards',
    SECTION: 'Section',
    IN_SCOPE: 'In scope',
    ACTIVE: 'Active',
    RESULT_LOADED: 'Result loaded',
    NO_RESULT: 'No result',
    CLIENT_ACTIVITY: 'Client activity',
    ACTIVITY_STATUS: { inUse: 'In use', atRisk: 'At risk', off: 'Off' },
    LAST_ACCESS: (days: number) => (days === 0 ? 'Today' : `${days}d ago`),
    NEVER_ACCESSED: 'Never accessed',
    NEVER_EDITED: 'Never edited',
    PAGE_LAST_ACCESS: 'Last access',
    PAGE_LAST_EDIT: 'Last edit',
    CAPABILITY_NOT_ACTIVE: 'Capability not active',
    LOGO: 'Logo',
    UPLOAD_LOGO: 'Upload logo',
    LANGUAGE: 'Language',
    DOMAINS: 'Domains',
    TEXT_EDITOR: 'Text editor documents',
    TEXT_EDITOR_INFO:
      'Serves policies from the built-in text editor instead of Google Drive. Documents show no versions until they are provisioned separately.',
    TIME_TO_RESOLVE: 'Time to resolve',
    TIME_TO_RESOLVE_INFO: 'Shows how long closed findings took to resolve in their drawers.',
    DEMO: 'Demo',
    IS_DEMO: 'Demo organization',
    IS_DEMO_INFO: 'Marks this organization as a demo tenant so seed data and demo-only features apply.',
    CONTACT_EMAIL: 'Contact email',
    ONBOARDING_DATE: 'Onboarding date',
    INTERNAL_AUDIT: 'Internal audit',
    EXTERNAL_AUDIT: 'External audit',
    NOT_SET: 'Not set',
    EDIT_STANDARDS: 'Edit standards',
    REMOVE_STANDARDS_WARNING: (standards: string) =>
      `Removing ${standards} deletes its controls, documents and evidence for this tenant. This can't be undone.`,
    SAVE: 'Save',
    CANCEL: 'Cancel',
    MDM: {
      TAB: 'MDM',
      NOT_SET_UP: 'MDM not set up',
      SET_UP: 'Set up MDM',
      SET_UP_AGAIN: 'Set up again',
      ENABLED: 'MDM enabled',
      STEPS: {
        TEAM: {
          TITLE: 'Set up the team in the MDM server',
          TASKS: {
            CREATE_TEAM: 'Create a team for this tenant',
            COPY_TEAM_ID: 'Copy its team ID into the field below',
            CREATE_USER: 'Create an admin API-only user for that team',
            COPY_TOKEN: 'Copy the API token of that user',
          },
        },
        SECRET: {
          TITLE: 'Store the token in AWS',
          DESCRIPTION: 'Create a secret in AWS Secrets Manager with this content',
        },
        LINK: { TITLE: 'Link the secret', DESCRIPTION: 'Paste the ARN of that secret and save' },
      },
      TEAM_ID: 'Fleet team ID',
      TEAM_ID_PLACEHOLDER: '<team ID>',
      TOKEN_PLACEHOLDER: '<API token>',
      COPY: 'Copy',
      SECRET_REF: 'Secret ARN',
      SECRET_REF_PLACEHOLDER: 'arn:aws:secretsmanager:...',
      LIBRARY: {
        TITLE: 'Qalea library',
        ADD: 'Add policy',
        NEW_TITLE: 'New library policy',
        EDIT_TITLE: 'Edit library policy',
        EMPTY: 'No library policies',
        SAVE: 'Save',
        CANCEL: 'Cancel',
        EDIT: 'Edit',
        DELETE: 'Delete',
        DELETE_TITLE: 'Delete library policy',
        DELETE_DESCRIPTION: (name: string) =>
          `${name} is removed for this client, and from their devices if they deployed it.`,
        SAVED: 'Library policy saved',
        DELETED: 'Library policy deleted',
      },
    },
    PHISHING_IMPORT: {
      TAB: 'Phishing',
      IMPORT: 'Import campaign',
      CONFIRM: 'Import',
      CANCEL: 'Cancel',
      CAMPAIGN: 'Campaign',
      LAUNCH_DATE: 'Launch date',
      PICK_DATE: 'Pick a date',
      TARGETED: 'Targeted',
      TARGETED_COUNT: (count: number) => `${count} targeted`,
      NO_CAMPAIGNS: 'No campaigns imported',
      SEARCH: 'Search campaigns',
      NO_RESULTS: 'No campaigns found',
      LOADING_CAMPAIGNS: 'Loading campaigns from CanIPhish…',
      IMPORTING: 'Importing the campaign from CanIPhish…',
      IMPORTING_HINT: 'This can take up to a minute. Keep this window open.',
      IMPORTING_BUTTON: 'Importing…',
      SUGGESTED: 'Suggested',
      IMPORTED: 'Imported',
      TEMPLATE: 'Template',
      TEMPLATE_MISSING: 'Missing',
      UPLOAD_TEMPLATE: 'Upload template',
      EMAIL_SCREENSHOT: 'Email screenshot',
      LANDING_SCREENSHOT: 'Landing page screenshot (optional)',
      UPLOAD: 'Upload',
      UPLOADING: 'Uploading…',
      TOAST_TEMPLATE_UPLOADED: (name: string) => `Template ${name} linked`,
      TOAST_SUCCESS: ({ matched, unmatched }: { matched: number; unmatched: number }) =>
        `Imported ${matched} results${unmatched ? `, ${unmatched} without an employee` : ''}`,
    },
    SEED_DEMO: {
      BUTTON_LABEL: 'Seed demo data',
      BUTTON_TOOLTIP: 'Requires Acme Corporation to be seeded with risks and non-conformities in this environment.',
      CONFIRM_TITLE: 'Seed demo data for this organization?',
      CONFIRM_DESCRIPTION:
        'This will seed demo employees, risks, non-conformities, and SaaS access for this organization. Pieces that already exist will be skipped.',
      CONFIRM_ACTION: 'Seed',
      CONFIRM_CANCEL: 'Cancel',
      TOAST_SUCCESS: ({
        employees,
        risks,
        nonConformities,
        documents,
        saas,
        skippedList,
      }: {
        employees: number
        risks: number
        nonConformities: number
        documents: number
        saas: number
        skippedList: string
      }) =>
        `Seeded: ${employees} employees, ${risks} risks, ${nonConformities} non-conformities, ${documents} documents, ${saas} SaaS links${skippedList ? ` (${skippedList})` : ''}`,
      TOAST_ERROR: ({ message }: { message: string }) => `Demo seeding failed: ${message}`,
      TOAST_ERROR_GENERIC: 'Demo seeding failed',
      SKIP_REASON_ALREADY_HAS_ASSETS: 'assets already present',
      SKIP_REASON_ALREADY_HAS_RISKS: 'risks already present',
      SKIP_REASON_ALREADY_HAS_NCS: 'non-conformities already present',
      SKIP_REASON_ALREADY_HAS_DEPARTMENTS: 'departments already present',
      SKIP_REASON_ALREADY_HAS_SUPPLIERS: 'suppliers already present',
      SKIP_REASON_ALREADY_HAS_TRUST_CENTER: 'trust center already present',
      SKIP_REASON_ALREADY_HAS_TASKS: 'tasks already present',
      SKIP_REASON_ALREADY_HAS_TEXT_DOCUMENTS: 'documents already present',
      SKIP_REASON_ALREADY_WITHIN_DEMO_SCOPE: 'scope already trimmed',
      SKIP_REASON_ALREADY_HAS_EASM_DATA: 'EASM data already present',
      SKIP_REASON_ALREADY_HAS_CSPM_DATA: 'CSPM data already present',
    },
  },
  COLUMNS: {
    TENANT: 'Tenant',
    STANDARDS: 'Standards',
    ARR: 'ARR',
    SECURITY_MANAGER: 'Security Manager',
    ONBOARDING: 'Onboarding',
    ONBOARDING_TIME: 'Onboarding time',
    ADOPTION_RATE: 'Adoption rate',
    TIME_TO_AUDIT: 'Time to audit',
    STATUS: 'Status',
  },
  STATUS: {
    ONBOARDING: 'Onboarding',
    LIVE: 'Live',
    AT_RISK: 'At risk',
    CHURN: 'Churn',
    NOT_PRODUCTION: 'Not production account',
    DEMO: 'Demo account',
    NOT_SET: 'Not set',
  },
}
